export const getTime = (currentTime: number) => {
  const seconds = String(Math.floor(currentTime % 60));
  return `${parseInt(String(currentTime / 60))}:${seconds.padStart(2, '0')}`;
};
